<template>
  <OChart :options="chartOptions" />
</template>

<script>
import OChart from '@components/Chart.vue'

const DECIMATION_SAMPLES = 1000
const SELECTED_BORDER_WIDTH = 2

const MUTED_ALPHA = '26'

const CURVE_COLORS = [
  '#2D62DD',
  '#2DAF32',
  '#A02DDD',
  '#FF741F',
  '#229CA0',
  '#E63737',
  '#CE3399',
  '#7B4336',
  '#585858',
]

const DEFAULT_CHART_OPTIONS = {
  animation: false,
  parsing: false,
  normalized: true,
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      type: 'time',
      time: {
        displayFormats: {
          millisecond: 'HH:mm',
          second: 'HH:mm',
          minute: 'HH:mm',
          hour: 'HH:mm',
          day: 'LLL d',
          week: 'LLL d',
          month: 'LLL d',
          quarter: 'LLL d',
          year: 'LLL d',
        },
        tooltipFormat: 'LLL d, HH:mm',
      },
    },
    y: {
      type: 'linear',
      suggestedMin: 0,
      suggestedMax: 100,
    },
  },
  interaction: {
    mode: 'nearest',
    intersect: false,
    axis: 'xy',
  },
  plugins: {
    decimation: {
      enabled: true,
      algorithm: 'lttb',
      samples: DECIMATION_SAMPLES,
    },
    legend: {
      display: false,
    },
    tooltip: {
      displayColors: true,
      callbacks: {
        label: function (context) {
          return ` ${context.dataset.label} — ${context.parsed.y} %`
        },
      },
    },
  },
}

export default {
  name: 'EditLiveReviewConsumptionChart',

  components: { OChart },

  props: {
    curves: {
      type: Array,
      required: true,
      validator: (v) =>
        v.every((obj) => ['id', 'name', 'colorIndex', 'points'].every((key) => key in obj)),
    },
    selectedTrackerId: {
      type: String,
      default: null,
    },
  },

  computed: {
    chartOptions() {
      return {
        type: 'line',
        options: {
          ...DEFAULT_CHART_OPTIONS,
          onClick: this.selectClickedCurve,
        },
        data: {
          datasets: this.curves.map((curve) => {
            const color = CURVE_COLORS[curve.colorIndex % CURVE_COLORS.length]
            const isSelected = curve.id === this.selectedTrackerId
            const isMuted = this.selectedTrackerId !== null && !isSelected

            return {
              label: curve.name,
              borderColor: isMuted ? `${color}${MUTED_ALPHA}` : color,
              backgroundColor: isMuted ? `${color}${MUTED_ALPHA}` : color,
              borderWidth: isSelected ? SELECTED_BORDER_WIDTH : 1,
              borderJoinStyle: 'round',
              order: isSelected ? 0 : 1,
              pointRadius: 0,
              pointHoverRadius: 6,
              pointHoverBorderWidth: 2,
              pointHoverBorderColor: '#fff',
              data: curve.points,
            }
          }),
        },
      }
    },
  },

  methods: {
    selectClickedCurve(event, activeElements) {
      const curve = activeElements.length ? this.curves[activeElements[0].datasetIndex] : null

      this.$emit('select', curve ? curve.id : null)
    },
  },
}
</script>
